import { getStoredConsent } from './consent';

/** Fail-open GA4 helpers for the marketing site (induce web stream). */
export function trackLandingEvent(
  eventName: string,
  params?: Record<string, unknown>,
): void {
  try {
    if (getStoredConsent() !== 'granted') return;
    const analyticsWindow = (globalThis as typeof globalThis & {
      window?: { gtag?: (...args: unknown[]) => void };
    }).window;
    const gtag = analyticsWindow?.gtag;
    if (typeof gtag !== "function") return;
    gtag("event", eventName, params);
  } catch {
    // Fail-open
  }
}
